import { render, staticRenderFns } from "./ManagerQuotaEditor.vue?vue&type=template&id=2ada541b&lang=pug&"
import script from "./ManagerQuotaEditor.vue?vue&type=script&lang=js&"
export * from "./ManagerQuotaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports